import React from 'react';
import { RiDashboardLine } from '@remixicon/react';
import {
  type IconComponent,
  createFrontendModule,
  PageBlueprint,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';

export const catalogPagesModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/catalog',
        routeRef: catalogPlugin.routes.catalogIndex,
        noHeader: true,
        loader: () =>
          import('./pages').then(m => React.createElement(m.CatalogPage)),
      },
    }),
    PageBlueprint.make({
      name: 'entity',
      params: {
        path: '/catalog/:namespace/:kind/:name',
        routeRef: catalogPlugin.routes.catalogEntity,
        noHeader: true,
        loader: () =>
          import('./entity.page').then(m =>
            React.createElement(m.EntityPage),
          ),
      },
    }),
    PageBlueprint.make({
      name: 'clients',
      params: {
        path: '/clients',
        noHeader: true,
        loader: () =>
          import('./pages').then(m => React.createElement(m.ClientsPage)),
      },
    }),
    NavItemBlueprint.make({
      params: {
        title: 'Catalog',
        icon: RiDashboardLine as IconComponent,
        routeRef: catalogPlugin.routes.catalogIndex,
      },
    }),
  ],
});
